<template>
  <div class="pagination-wrapper">
    <div class="pagination-wrapper__wishlist">
      <div class="pagination-wrapper__wishlist__info">
        <button v-if="isWishlistOwner" class="button button__remove" @click="removeAllFromWishlist()">
          {{ this.translations.removeAll }}
          <i data-feather="x"></i>
        </button>

        <div class="pagination-wrapper__wishlist__add-to-cart">
          <div class="pagination-wrapper__wishlist__sum">
            <span>
              {{ this.translations.totalSum }}:
            </span>
            <span>
              <Price
              :regularPrice="this.getTotal()"
              :salePrice="0"
              />
              {{ getVatStatusTranslation() }}
            </span>
          </div>

          <button class="button" @click="addAllToCart()">
            <i data-feather="shopping-cart"></i>
            {{ getAddAllString() }}
          </button>
        </div>
      </div>
    </div>

    <div class="pagination-row">

      <div class="pagination-row__actions">
        <div class="perpage">
          <p>
            <span>{{ translations.perPage }}: </span>
          </p>

          <div class="perpage__buttons">
            <button
              v-for="option in $store.state.view.perPageOptions"
              :key="option"
              :class="{ active: option === $store.state.view.perPage }"
              @click="setSelectedPerPage(option)"
            >
              {{ option }}
            </button>
          </div>
        </div>

        <div class="select-view">
          <div class="select-view__table">
            <button v-bind:class="[this.$store.state.view.type == 'wells' ? 'selected' : '']" v-on:click="setView('wells')">
              <i data-feather="pause"></i>
            </button>
          </div>
          <div class="select-view__grid">
            <button v-bind:class="[this.$store.state.view.type == 'kaali' ? 'selected' : '']" v-on:click="setView('kaali')">
              <i data-feather="grid"></i>
            </button>
          </div>
        </div>

      </div>

      <div class="select-page">
        <button
          class="select-page__prev"
          v-on:click="prevPage"
          v-bind:class="{ disabled: this.$store.state.view.page == 1 }"
        >
          <span>‹</span>
        </button>
        <p>{{ $store.state.view.page }} / {{ this.getPageCount }}</p>
        <button
          class="select-page__next"
          v-on:click="nextPage"
          v-bind:class="{ disabled: this.$store.state.view.page == this.getPageCount }"
        >
          <span>›</span>
        </button>
      </div>

      <v-pagination
        v-model="$store.state.view.page"
        v-if="getPageCount > 0"
        :page-count="getPageCount"
        :classes="pagination.classes"
        :labels="pagination.anchorTexts"
        @input="setPage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import Price from "@/layouts/general-ui/Price.vue";
import vPagination from "vue-plain-pagination";
import FragmentsRenderer from '@/externals/FragmentRenderer';
import feather from 'feather-icons';

export default {
  components: {
    Price,
    vPagination
  },
  name: "PaginationWells",
  data() {
    return {
      translations: {
        withVat: ws_vue_store.translations.included_vat,
        withoutVat: ws_vue_store.translations.excluded_vat,
        removeAll: ws_vue_store.translations.wishlist_remove,
        totalSum: ws_vue_store.translations.wishlist_total,
        addAll: ws_vue_store.translations.wishlist_add_all,
        addAllError: ws_vue_store.translations.wishlist_add_all_error,
        clearWishlistError: ws_vue_store.translations.wishlist_clear_error,
        sort: ws_vue_store.translations.sort,
        perPage: ws_vue_store.translations.per_page,
        postsFound: ws_vue_store.translations.posts_found,
        emptyFilters: ws_vue_store.translations.empty_filters
      },
      sorts: ws_vue_store.catalog_orderby_options,
      pagination: {
        currentPage: this.$store.state.view.page,
        classes: {
          ul: "pagination",
          li: "pagination-item",
          liActive: "pagination-item--active",
          liDisable: "pagination-item--disable",
          button: "pagination-link",
          buttonActive: "pagination-link--active",
          buttonDisable: "pagination-link--disable"
        },
        anchorTexts: {
          first: "&laquo;",
          prev: "&lsaquo;",
          next: "&rsaquo;",
          last: "&raquo;"
        },
      },
      isBurgerActive: false,
    };
  },
  computed: {
    includingTax() {
      return this.$store.getters.getTaxesEnabled;
    },
    isLoading() {
      return this.$store.state.view.isLoading;
    },
    hasActiveFilters() {
      return this.$store.getters.getActiveFiltersCount > 0;
    },
    isWishlistView() {
      return this.$router.currentRoute.name === "Wishlist";
    },
    isWishlistOwner() {
      return this.$store.getters.getIsViewWishlistOwner;
    },
    getPageCount() {
      return Math.ceil(this.$store.state.productsCount / this.$store.state.view.perPage);
    },
    getShowedProductsCount() {
      let minPerPage = (this.$store.state.view.page - 1) * this.$store.state.view.perPage + 1;
      if (this.$store.state.productsCount < this.$store.state.view.perPage) {
        return this.$store.state.productsCount;
      }
      if (this.$store.state.view.page == this.getPageCount) {
        let lessPerPage =
          this.$store.state.view.page * this.$store.state.view.perPage -
          this.$store.state.productsCount;
        let maxPerPage = this.$store.state.view.page * this.$store.state.view.perPage - lessPerPage;
        return minPerPage + "-" + maxPerPage;
      }
      let maxPerPage = this.$store.state.view.page * this.$store.state.view.perPage;
      return minPerPage + "-" + maxPerPage;
    },
    viewCount() {
        return this.$store.state.wishlist.viewCount;
    }
  },
  methods: {
    async addAllToCart() {
      if ( !this.$router.currentRoute.params.wishlist_uid) {
        return;
      }
      const params = new URLSearchParams();
      params.append('action', 'add_wishlist_to_cart');
      params.append('uniqueid', this.$router.currentRoute.params.wishlist_uid);

      const {data} = await this.axios.post(ws_vue_store.ajax_url, params)
      .catch(function (error) {
        console.log(error);
      });

      if (data.success) {
        if (data.data.fragments) {
          FragmentsRenderer.renderFragments(data.data.fragments);
          feather.replace();
        }

        this.$store.dispatch("displayWoocommerceNotice", {
          message: data.data.msg
        });

      } else if (data.data && data.data.errors) {
        for (const message of data.data.errors) {
          this.$store.dispatch("displayWoocommerceNotice", {
            message: message,
            extraClass: 'woocommerce-error'
          });
        }

      } else {
        this.$store.dispatch("displayWoocommerceNotice", {
          message: this.translations.addAllError,
          extraClass: 'woocommerce-error'
        });
      }
    },
    async removeAllFromWishlist() {
      this.$store.commit('changeProductsLoadingState', true);

      const params = new URLSearchParams();
      params.append('action', 'clear_active_wishlist');

      const {data} = await this.axios.post(ws_vue_store.ajax_url, params)
      .catch(function (error) {
        console.log(error);
      });

      if (data.success) {
        this.$store.commit('setProductsCount', 0);
        this.$store.commit('setProducts', []);

        if (data.data.fragments) {
          FragmentsRenderer.renderFragments(data.data.fragments);
          feather.replace();
        }

        this.$store.dispatch("displayWoocommerceNotice", {
          message: data.data.msg
        });
      } else if (data.data && data.data.msg) {
        this.$store.dispatch("displayWoocommerceNotice", {
          message: data.data.msg,
          extraClass: 'woocommerce-error'
        });
      } else {
        this.$store.dispatch("displayWoocommerceNotice", {
          message: this.translations.clearWishlistError,
          extraClass: 'woocommerce-error'
        });
      }

      this.$store.commit('changeProductsLoadingState', false);
    },
    getTotal() {
      return this.$store.getters.getViewWishlistTotal;
    },
    getVatStatusTranslation() {
      if (this.includingTax) {
        return this.translations.withVat;
      } else {
        return this.translations.withoutVat;
      }
    },
    getAddAllString() {
      return this.translations.addAll.replace('%s', this.viewCount);
    },
    setView(value) {
      if (window.innerWidth <= 1350) {
        value = 'kaali';
      }
      this.$store.commit("changeViewType", value);
    },
    setSelectedPerPage(value) {
      this.$store.commit("changePerPage", value);
      this.$store.commit("setFirstPage");
      this.$store.dispatch("getProducts");
    },
    setPage() {
      this.$store.commit("changeCurrentPage", this.$store.state.view.page);
      this.$store.dispatch("getProducts");
    },
    nextPage() {
      if (this.$store.state.view.page < this.getPageCount) {
        this.$store.commit("changeCurrentPage", (this.$store.state.view.page += 1));
        this.$store.dispatch("getProducts");
      }
    },
    prevPage() {
      if (this.$store.state.view.page > 1) {
        this.$store.commit("changeCurrentPage", (this.$store.state.view.page -= 1));
        this.$store.dispatch("getProducts");
      }
    }
  },
  mounted() {
    feather.replace();
  },
};
</script>

<style lang="scss">
.pagination-row {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 0 2rem;

  > div {
    .vs--single.vs--open .vs__selected {
      position: relative;
    }

    .vs5__listbox {
      width: 100%;
    }

    .vs {
      &--searchable {
        padding: 0 1rem;
      }

      &--single {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        ul {
          position: absolute;
          top: 100%;
          right: 0;
          left: inherit;
          z-index: 9;
          width: 100%;
          font-size: 1.6rem;
          background-color: $color-white;
          border: 1px solid $color-black;
          border-radius: 0 0 1rem 1rem;
        }

        &.vs--open {
          .vs__dropdown-toggle {
            border-bottom: 0;
            border-radius: 1rem 1rem 0 0;
          }
        }
      }

      &__actions {
        svg {
          transform: scale(0.6);
        }
      }

      &__dropdown-menu {
        padding: 0;
      }

      &__dropdown-option {
        padding: 1rem 2rem;
        white-space: wrap;

        &--highlight {
          color: $color-white;
          background-color: #006646;
        }
      }

      &__dropdown-toggle {
        display: flex;
        gap: 4rem;
        align-items: center;
        padding: 1rem 1.4rem 1rem 2rem;
        background: none;
        border: 1px solid black;
        border-radius: 1rem;
        white-space: normal;
        appearance: none;

        @include small {
          width: 100%;
          justify-content: space-between;
        }
      }

      &__selected-options {
        display: flex;
        line-height: 100%;

        input {
          display: none;
        }
      }
    }
  }

  .select-page {
    button {
      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
  }

  .pagination {
    display: flex;

    &-item {
      padding: 0 1rem;
      align-self: center;
    }
  }

  .select-view {
    button {
      opacity: 0.9;
      transition: all .3s ease-in-out;

      &:not(.selected) {
        opacity: 0.3;
      }

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>